import { useCallback, useMemo } from 'react'

import { Room } from '@/core/models/room.model'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { joinMeeting } from '@/redux/reducers/consultation.reducer'

type UseJoinMeetingParams = {
  consultationId?: string
  room?: Room
}

export function useJoinMeeting({ consultationId, room }: UseJoinMeetingParams) {
  const dispatch = useAppDispatch()
  const authUser = useAppSelector(selectAuthUser)

  const isStreamer = useMemo(() => {
    if (!authUser || !room) return false
    return authUser._id === (typeof room.creator === 'string' ? room.creator : room.creator._id)
  }, [authUser, room])

  const handleJoinMeeting = useCallback(() => {
    if (!consultationId || !authUser?._id) return

    dispatch(joinMeeting({ roomOrConsultationId: consultationId, userId: authUser._id, meetingType: 'visioConference' }))
  }, [dispatch, consultationId, authUser])

  return {
    handleJoinMeeting,
    isStreamer,
  }
}
